// SearchBar/style.ts
import { styled } from "@mui/material/styles";
import { Box, TextField } from "@mui/material";
import { WidthFull } from "@mui/icons-material";

/**
 * Основной контейнер, который будет оборачивать
 * иконку, поле ввода и кнопку фильтра (если есть).
 */
export const SearchBarContainer = styled(Box)(() => ({
  // Чтобы 'gap' работал, нужно display: 'flex'
  display: "flex",
  alignItems: "center",
    justifyContent: "space-beetwen",
  width: 590,
  height: 40,

  paddingTop: 8,
  paddingRight: 8,
  paddingBottom: 8,
  paddingLeft: 16,

  gap: 12, // Расстояние между внутренними элементами

  //borderRadius: 24,
  //borderWidth: 1,
  //borderStyle: "solid",
  //borderColor: "#ccc", // или любой другой цвет рамки
}));

/**
 * Если нужно переопределить стили самого TextField,
 * можно создать StyledTextField (по аналогии выше).
 * Например, чтобы убрать обводку или изменить размер.
 */
export const StyledTextField = styled(TextField)(() => ({
  // Пример: убираем outline / выставляем другие отступы
  "& .MuiOutlinedInput-root": {
    padding: 0,
    // Вместо стандартной высоты MUI
    height: "100%",
    // Можно настроить стили border-radius поля,
    // если оно должно совпадать с общим контейнером
    borderRadius: 24,
    width: 510
  },
}));
